module.exports = __webpack_public_path__ + "static/button-addons-65565ac53befd54f930ee930790e6772.svg";